export function getFilename(contentDispositionValue) {
  return (
    contentDispositionValue
      ?.split(";")
      ?.map((s) => s.trim().split("="))
      ?.find((v) => v[0] === "filename")?.[1]
      ?.match(/^"?(.*?)"?$/)?.[1] ?? "unknown"
  );
}

export function getFileExtension(filename) {
  return filename.substring(filename.lastIndexOf(".") + 1);
}
